<template lang="html">
  <div class="row">
    <div class="col-md-12">
      <button type="button" class="btn btn-primary" @click="showModal()">Nuevo</button>
    </div>
    <modal :show.sync="show_modal" large="true" effect="fade" backdrop="false">
      <div slot="modal-header" class="modal-header">
        <h4 class="modal-title">Nueva Copa</h4>
      </div>
      <div slot="modal-body" class="modal-body">
        <awards-form  :award="award"></awards-form>
      </div>
      <div slot="modal-footer" class="modal-footer">
        <button type="button" class="btn btn-default" @click='closeModal'>Cerrar</button>
        <button type="button" class="btn btn-primary" @click='saveAward'>Guardar</button>
      </div>
    </modal>
  </div>
</template>

<script>
import Award from '../../api/award'
import {modal} from 'vue-strap'
import AwardsForm from './AwardsForm'
import {getConfigChampionship} from '../../vuex/getters'
import * as actions from '../../vuex/actions'
export default {
  vuex: {
    getters: {
      championship: getConfigChampionship
    },
    actions
  },
  data ()
   {
    return {
      show_modal: false,
      award: {
        name: null,
        class: null,
        championship_id: null
      }
    }
  },
  computed: {},
  methods: {
    showModal() {
      this.award = {
        name: null,
        class: null,
        championship_id: null
      }
      this.show_modal = true
    },
    closeModal() {
      this.show_modal = false
    },
    saveAward() {
      this.award.championship_id = this.championship.id
      let awardApi = new Award()
      awardApi.post(this.award).then(response => {
        this.award = response.data
        this.fetchConfigAwards()
        this.show_modal = false
      })
    }
  },
  components: { modal, AwardsForm }
}
</script>

<style lang="css">
</style>



/** WEBPACK FOOTER **
 ** AwardsNew.vue?2808a330
 **/